import { useContext, useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";

//App
import {
  LookupValueContextData,
  LookupValueFormProps,
} from "../../../../types/lookupValue";
import { LookupValueContext } from "./LookupValueContainer";
import { EMPTY_GUID } from "../../../../utility/constants";
import { useLookupTypeQuery } from "../../../Admin/Lookup/LookupType/hooks/useLookupType";

//Common
 import FormHeader from "../../../common/Forms/FormHeader/FormHeader";
import TextField from "../../../common/VFX-UI/TextField/TextField";
import ActionBar from "../../../common/ActionBar/ActionBar";
import AutoComplete from "../../../common/VFX-UI/Autocomplete/Autocomplete";
import { Container } from "reactstrap";
import { FormBackGround } from "../../../common/Forms";
import { Chip } from "../../../common/VFX-UI";

const createValidationSchema = (isLookupTypeGrouped: boolean) => {
  return Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string().required("Description is required"),
    lookupTypeId: Yup.array()
      .min(1, "Lookup Type is required")
      .required("Lookup Type is required"),
    lookupGroupId: isLookupTypeGrouped
      ? Yup.array()
          .min(1, "Lookup Group is required")
          .required("Lookup Group is required")
      : Yup.array().nullable(),
    sortValue: Yup.number().min(0, "Must be positive number"),
  });
};

const LookupValueForm = (props: LookupValueFormProps) => {
  const { status, initialVal, onClose, handleOnSubmit } = props;
  const { id, lookupTypeId, lookupGroupId } = initialVal;

  const formRef = useRef<FormikProps<any>>(null);

  const lookupvalueContext = useContext<LookupValueContextData | null>(
    LookupValueContext
  );

  const lookupType = useLookupTypeQuery(
    lookupTypeId && lookupTypeId?.length > 0 ? lookupTypeId[0] : null
  );

  const isLookupTypeGrouped = lookupType?.data?.result?.isGrouped ?? false;

  const titleName = lookupvalueContext?.lookupType?.name;

  const title = id === EMPTY_GUID ? `New ${titleName}` : `Edit ${titleName}`;

  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  const validationSchema = createValidationSchema(isLookupTypeGrouped);

  return (
    <FormBackGround>
      <FormHeader title={title} onClose={onClose} />
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={initialVal}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {({ values }) => (
          <Container>
            <Form noValidate>
              <div className="d-flex justify-content-end mb-3 me-3">
                <Chip label={values.isActive ? "Active" : "Inactive"} />
              </div>
              <TextField
                label="Name"
                type="text"
                name="name"
                isRequired={true}
              />
              <TextField
                label="Description"
                type="textarea"
                name="description"
                isRequired={true}
              />
              <AutoComplete
                disabled={true}
                name="lookupTypeId"
                label="Lookup Type"
                isRequired={true}
                options={lookupvalueContext?.lookupTypes ?? []}
                defaultSelected={
                  lookupTypeId != null && lookupTypeId.length > 0
                    ? [lookupTypeId[0]]
                    : []
                }
              />
              {lookupvalueContext?.lookupType?.isGrouped && (
                <AutoComplete
                  name="lookupGroupId"
                  label="Lookup Group"
                  isRequired={true}
                  options={lookupvalueContext?.lookupGroups ?? []}
                  defaultSelected={
                    lookupGroupId != null && lookupGroupId.length > 0
                      ? [lookupGroupId[0]]
                      : []
                  }
                />
              )}
              <TextField label="Display Order" type="number" name="sortValue" />
              <ActionBar
                submitHandler={saveInput}
                cancelHandler={onClose}
                submitText="Submit"
                cancelText="Cancel"
                isLoading={status === "pending"}
              ></ActionBar>
            </Form>
          </Container>
        )}
      </Formik>
    </FormBackGround>
  );
};

export default LookupValueForm;
